import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {Avatar} from 'components/common/app';
import {CardContainer, Notification, Badge, Loading} from 'components/common/uiKit';

import {CourseApi} from 'services/network/api'
import {serverUrl} from 'services/network'
import * as RouteService from 'services/route'

class StudentsTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: props.courseId,
            data: [],
            loading: true
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const {courseId} = this.state;
        if (courseId) {
            this.setState({loading: true});

            CourseApi.GetCourseUsers(courseId)
                .then(res => {
                    if (res.status == 200) {
                        let {data} = res;
                        data = data.sort((x, y) => x.state == 2 ? -1 : 1);
                        this.setState({data});
                    }
                }).finally(x=>{
                    this.setState({loading: false});
            })
        }
    }

    _applyState = item => {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Course.Student.State;

        let res = {type: '', text: ''};
        const {graduated, stateTxt} = item;
        if (graduated) {
            res.text = pageTranslates.Graduated;
            res.type = 'success';
        } else {
            if (stateTxt && stateTxt.toUpperCase() == 'PENDING') {
                res.type = 'primary';
                res.text = pageTranslates.Pending;
            }
        }
        return res;
    };

    _handleItemClick = (item) => {
        if (item.stateTxt.toUpperCase() == 'PENDING') {
            const {history} = this.props;
            const {levelId, userId} = item;
            history.push({
                pathname: `admin/level?levelId=${levelId}&userId=${userId}`,
                //search: `?lessonId=${id}`,
                //state: {...data}
            });
        }
    };

    render() {
        const {data, loading} = this.state;

        if (loading)
            return <Loading/>;

        return (
            <CardContainer>
                {data.map((item, index) => {
                    const {username, userAvatar, userFullName, graduated} = item;
                    const state = this._applyState(item);

                    let avatar = userAvatar ? serverUrl + userAvatar : '';

                    return (
                        <>
                            <div className="user-slider" onClick={this._handleItemClick.bind(this, item)}>
                                <div className="d-flex">
                                    <div className='ml-3'>
                                        <Avatar src={avatar}/>
                                    </div>
                                    <div>
                                        <h5 className="mt-1 mb-0">
                                            {username}
                                        </h5>
                                        <p className="font-10 mt-1 color-primary">
                                            {userFullName}
                                        </p>
                                    </div>
                                    <div className="mr-auto">
                                        {state.type &&
                                        <Badge type={state.type} text={state.text} classes='next-slide-user'/>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="divider mt-3"></div>
                        </>
                    );
                })}
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(StudentsTab));
